import { Box, Grid, Spinner, Text } from '@factorialco/deprecated-design-system'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import i18n from 'modules/core/lib/i18n'

import { useGetProductUpdates } from 'modules/product_updates/hooks/useGetProductUpdates'

import BenefitsBanner from '../BenefitsBanner'
import UpdatesWithCEOItem from './_Item'

const UpdatesWithCEOList = () => {
  const { company } = useCurrentSession()
  const { productUpdates, loading } = useGetProductUpdates({
    featuredIn: 'launches_with_ceo_q1',
  })

  if (loading) {
    return (
      <Box alignItems="center">
        <Spinner />
      </Box>
    )
  }

  if (productUpdates.length === 0) {
    return (
      <Box alignItems="center">
        <Text.Normal>{i18n.t('product_updates.filters.no_results')}</Text.Normal>
      </Box>
    )
  }

  const firstSetOfUpdates = productUpdates.slice(0, 3)
  const remainingUpdates = productUpdates.slice(3, productUpdates.length)
  const mainLegalEntity = company.legalEntities.find((legalEntity) => legalEntity.main)
  const isSpanishCompany = mainLegalEntity?.country === 'es'

  return (
    <Box gap="s12" style={{ maxWidth: '1440px', alignItems: 'center', justifyContent: 'center' }}>
      <Grid variant="fixed">
        {firstSetOfUpdates.map((update) => (
          <Box
            key={update.id}
            gridColSpan={{
              xxs: 12,
              xs: 12,
              s: 6,
              m: 4,
              l: 4,
            }}
          >
            <UpdatesWithCEOItem key={update.id} {...update} />
          </Box>
        ))}
      </Grid>

      <Box style={{ maxWidth: '1440px', width: '100%' }}>
        {isSpanishCompany && <BenefitsBanner />}
      </Box>

      <Grid variant="fixed">
        {remainingUpdates.map((update) => (
          <Box
            key={update.id}
            gridColSpan={{
              xxs: 12,
              xs: 12,
              s: 6,
              m: 4,
              l: 4,
            }}
          >
            <UpdatesWithCEOItem key={update.id} {...update} />
          </Box>
        ))}
      </Grid>
    </Box>
  )
}

export default UpdatesWithCEOList
